import { defineMessages } from 'react-intl';

export default defineMessages({
  surveyPreview: 'Podgląd ankiety',
  surveyNumber: 'Pytanie nr. {number}',
});
